/**
 * Site-level content: brand, contact, nav, hero, CTA.
 */
export const brand = {
  name: "The Artificer's AI",
  tagline: 'AI Systems & Enterprise Enablement',
  locator: 'Perth, AU',
  url: 'https://www.artificersai.com',
};

export const contact = {
  email: 'headartificer@artificersai.com',
  phone: '+61 433 987 271',
  phoneHref: 'tel:+61433987271',
};

// Leading slash so the links work from every route, not just the homepage:
// on / the browser treats them as a plain hash jump; on /intake or a spoke
// page they navigate home first, then scroll to the section.
export const navLinks = [
  { href: '/#for-who', label: 'Who it is for' },
  { href: '/#offers', label: 'What we do' },
  { href: '/case-studies', label: 'Case Studies' },
  { href: '/#how-we-work', label: 'How we work' },
  { href: '/#process', label: 'Process' },
  { href: '/#faq', label: 'FAQ' },
];

export const hero = {
  status: 'Now booking new engagements. Built in Perth, working worldwide.',
  headline: 'People are creatives.',
  headlineAccent: 'Everything else can be a system.',
  subhead:
    'We audit your operations, rank the highest-ROI opportunities, and build the systems that run them. Then we train your staff to own it.',
  ctaPrimary: { label: 'Talk to Merlin', href: '/intake' },
  ctaSecondary: { label: 'See what we build', href: '#offers' },
};

export const cta = {
  headline: 'Talk to Merlin',
  headlineAccent: 'to break down your problem.',
  body:
    "Tell Merlin what's slowing you down. We map your workflows, find the highest-return opportunities, and send a scope-based proposal within 48 hours.",
  primary: { label: 'Talk to Merlin', href: '/intake' },
  simulator: {
    welcomeCommand: 'merlin --initialize --intake',
    systemResponse: '[SYSTEM] Connecting to Merlin intake agent... v1.4.0 active.',
    merlinGreeting: '"Greetings. I am Merlin. Select one of the business sectors below to run a mockup diagnostic on your operations:"',
    sectors: [
      {
        id: 'leads',
        code: '01_lead_capture',
        label: 'Lead Capture & CRM Routing',
        logs: [
          '[PARSE] Scanning inbound lead parameters...',
          '[IDENTIFY] Found manual CRM key-ins (12.5 hrs/week average).',
          '[SYSTEM DESIGN] Formulating automated intake router...'
        ],
        result: {
          title: 'Diagnostic Result: Automation Pipeline Built',
          source: 'Scattered inbound email leads & forms',
          engine: 'LLM Lead Intent Classifier',
          action: 'Syncs to CRM, sends high-priority Slack alerts',
          impact: '12.5 hours/week saved, instant client follow-up'
        }
      },
      {
        id: 'invoices',
        code: '02_invoice_processing',
        label: 'Invoice Processing & Accounting',
        logs: [
          '[PARSE] Ingesting test invoices...',
          '[IDENTIFY] Scanning table line-items manually entered into accounting databases.',
          '[SYSTEM DESIGN] Formulating OCR ingestion engine...'
        ],
        result: {
          title: 'Diagnostic Result: Document Parser Architecture',
          source: 'Supplier invoice PDFs in raw attachments',
          engine: 'OCR text extractor + Schema validator',
          action: 'Maps line items and updates accounting database',
          impact: '98% error reduction, turnaround time down 4x'
        }
      },
      {
        id: 'reporting',
        code: '03_analytics_sync',
        label: 'Analytics Pipelines & Reporting',
        logs: [
          '[PARSE] Querying reporting latency...',
          '[IDENTIFY] Found manual CSV merging and dashboard assembly cycles.',
          '[SYSTEM DESIGN] Configuring sync pipeline...'
        ],
        result: {
          title: 'Diagnostic Result: Analytics Sync Routine',
          source: 'Weekly sales database tables & logs',
          engine: 'DBT automation layer + LLM insight generator',
          action: 'Generates real-time CEO dashboard metrics',
          impact: 'Real-time visibility, 0 manual deck compilation'
        }
      }
    ]
  }
};

export const footerLinks = [
  { href: '/foundry', label: 'The Foundry' },
  { href: '/automated-systems', label: 'Automated Systems' },
  { href: '/team-training', label: 'Team Training' },
  { href: '/about', label: 'About' },
  { href: '/process', label: 'Process' },
  { href: '/adventure-logs', label: 'Adventure Logs' },
];
